import React, { FunctionComponent } from 'react';
import { AirlineInfo } from '@lt/api/dist/methods/packages/types';
import Bubble from '@lt/components/components/Bubble/Bubble';
import { QuestionTip } from '@lt/components/icons-react';
import {
  CompanyName,
  StyledBubbleContent,
  StyledBubbleLabel,
  StyledBubbleText,
  StyledFlightTypeRegular,
  Title,
  TitleWrapper,
  Wrapper,
} from './FlightType.style';
import { FLIGHT_TYPES } from './constants';

type Props = {
  className?: string;
  airline: AirlineInfo;
  parentWidth?: number;
  type: {
    flightType: string;
    flightClass: string;
  };
};

export const FlightType: FunctionComponent<Props> = (props: Props) => {
  const { type, className, airline, parentWidth } = props;
  const { flightType } = type;

  const { title, tooltip } = FLIGHT_TYPES[flightType];

  return (
    <Wrapper className={className}>
      <StyledFlightTypeRegular width={24} height={24} />
      <div>
        <CompanyName>{airline?.name}</CompanyName>
        <TitleWrapper parentWidth={parentWidth}>
          <Title>{title}</Title>
          <Bubble text={<StyledBubbleText>{tooltip}</StyledBubbleText>}>
            <StyledBubbleContent>
              <StyledBubbleLabel parentWidth={parentWidth}>Возможны доплаты</StyledBubbleLabel>
              <QuestionTip width={16} height={16} />
            </StyledBubbleContent>
          </Bubble>
        </TitleWrapper>
      </div>
    </Wrapper>
  );
};
